export default {
  title: 'Forgot your password?',
  subtitle: 'We will send you an email with a verification code',
  buttonContinue: 'Continue',
  placeholder: {
    email: 'Email',
  },
};
